import React, { memo } from 'react';

const DeleteTagButton = ({ className, onClick, tabIndex }) => (
  <button data-bem="DeleteTagButton" className={className} tabIndex={tabIndex} onClick={onClick} />
);

export default memo(DeleteTagButton);
